export const fetchFromAPI = async (endpoint: string, options?: RequestInit) => {
  try {
    const requestInit: RequestInit = {
      method: options?.method,
      headers: options?.headers,
      body: options?.body,
      ...options,
    };

    const response = await fetch(endpoint, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.json();
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }
    throw new Error('Unknown error');
  }
};
